import { render } from "./EditProductModal.vue?vue&type=template&id=63faa2d0&scoped=true"
import script from "./EditProductModal.vue?vue&type=script&lang=js"
export * from "./EditProductModal.vue?vue&type=script&lang=js"

import "./EditProductModal.vue?vue&type=style&index=0&id=63faa2d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63faa2d0"]])

export default __exports__